/**
 * External dependencies
 */

export default class Authentication {
	constructor(cscom) {
		if (!(this instanceof Authentication)) {
			return new Authentication(cscom);
		}
		this.cscom = cscom;
	}

	login(username, password) {
		return this.cscom.req.post('/authentication/sign-in', null, { username, password });
	}

	jwtLogin(jwt) {
		return this.cscom.req.get('/authentication/jwt-sign-in', { jwt });
	}
}
